export enum BREAKPOINTS {
  XS = '0px',
  SM = '600px',
  MD = '900px',
  LG = '1200px',
  XL = '1536px',
}
